// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"570":"c29471c1","787":"e34888e8","881":"cef7edf6"}[chunkId] + ".chunk.js";
};